import { render } from "./SpreadsheetViewer.vue?vue&type=template&id=1270ea99&scoped=true"
import script from "./SpreadsheetViewer.vue?vue&type=script&lang=js"
export * from "./SpreadsheetViewer.vue?vue&type=script&lang=js"

import "./SpreadsheetViewer.vue?vue&type=style&index=0&id=1270ea99&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1270ea99"]])

export default __exports__